import { h } from 'preact';
import { WithStyles } from '../../../style';

export enum PromoCodeInputState {
  DEFAULT = 'input-default',
  ERROR = 'input-error',
}

export interface PromoCodeInputProps {
  label: string;
  state?: PromoCodeInputState;
  errorText?: string;
}

export type InputElement = Partial<h.JSX.HTMLAttributes<HTMLInputElement>>;

export type EffectiveProps = PromoCodeInputProps & WithStyles & InputElement;
